/**
 * Free gift card offer on the sample kit page. Loaded only by
 * snippets/sample-gift-offer.liquid, so the PDP and every other page keep the
 * stock Buy now in main-sample-product.js and are never touched by this file.
 *
 * Buy now here:
 *   1. empties the cart,
 *   2. adds the kit plus the gift, the gift tagged `_offer_gift_for` with the
 *      kit's product id,
 *   3. goes to checkout through /discount/<code> so the code that makes the
 *      gift free is already applied.
 *
 * The listener runs in the capture phase and stops the event there, so the
 * stock handler in main-sample-product.js never runs on this page and the kit
 * isn't added twice.
 *
 * While the shopper is on this page, a tagged gift whose kit has left the cart
 * is removed too. A gift card bought on its own has no tag and is left alone.
 *
 * Every step logs to the console under [gift-offer].
 */
(function () {
  const ATC_SELECTOR = '.product-atc, .product__sticky__bar-add-cart';
  const log = (...args) => console.log('[gift-offer]', ...args);

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {})
    }).then((res) =>
      res.json().then((data) => {
        if (!res.ok) {
          const error = new Error(data.description || data.message || url + ' failed (' + res.status + ')');
          error.data = data;
          throw error;
        }
        return data;
      })
    );
  }

  log('loaded');

  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest(ATC_SELECTOR);
      if (!btn) return;
      const offer = document.querySelector('[data-gift-offer]');
      if (!offer) return;

      e.preventDefault();
      e.stopPropagation();

      // Same one-time purchase interception as the stock handler; the popup
      // clicks the button again once the shopper has chosen.
      const purchaseOption = document.querySelector('input[name="purchase-option"]:checked');
      if (
        purchaseOption &&
        purchaseOption.value === 'onetime' &&
        window.ctrSubscriptionPopup &&
        window.ctrSubscriptionPopup.intercept()
      ) {
        log('subscription popup intercepted the click');
        return;
      }

      const productInput = document.querySelector('.product-input');
      const variantId = productInput ? productInput.value : null;
      if (!variantId) {
        console.error('[gift-offer] no kit variant id found on the page');
        return;
      }

      btn.classList.add('loading');

      const quantityInput = document.querySelector('.quantity__input');
      const qty = (quantityInput && parseInt(quantityInput.value, 10)) || 1;

      let sellingPlanId = null;
      if (purchaseOption && purchaseOption.value === 'subscription') {
        const subscriptionSelect = document.querySelector('#global-subscription-plan');
        if (subscriptionSelect) sellingPlanId = subscriptionSelect.value;
      }

      const items = [
        {
          id: Number(variantId),
          quantity: qty,
          ...(sellingPlanId && { selling_plan: sellingPlanId })
        }
      ];
      if (window.ctrSubscriptionPopup && window.ctrSubscriptionPopup.applyToItems) {
        window.ctrSubscriptionPopup.applyToItems(items);
      }

      const giftVariantId = Number(offer.dataset.giftVariantId);
      if (giftVariantId) {
        items.push({
          id: giftVariantId,
          quantity: 1,
          properties: { _offer_gift_for: productInput.dataset.productid }
        });
      } else {
        console.warn('[gift-offer] no gift card product picked in the block — adding the kit only');
      }

      const discount = (offer.dataset.giftDiscount || '').trim();

      log('clearing cart');
      postJson('/cart/clear.js')
        .then((cart) => {
          if (cart.item_count) throw new Error('cart still has ' + cart.item_count + ' items after clearing');
          log('cart cleared, adding', items);
          return postJson('/cart/add.js', { items: items });
        })
        .then((added) => {
          log('added', added.items || added);
          const target = discount
            ? '/discount/' + encodeURIComponent(discount) + '?redirect=' + encodeURIComponent('/checkout')
            : '/checkout';
          log('going to', target);
          window.location.href = target;
        })
        .catch((err) => {
          console.error('[gift-offer] Buy now failed:', err, err.data || '');
          alert(err.message || 'Could not add item to cart. It may be sold out.');
          btn.classList.remove('loading');
        });
    },
    true
  );

  // sidecart.js announces every cart it paints; drop tagged gifts whose kit
  // is gone, then let the drawer repaint.
  document.addEventListener('mozi:cart:updated', function (e) {
    const items = (e.detail && e.detail.cart && e.detail.cart.items) || [];
    const productIds = new Set(items.map((item) => String(item.product_id)));
    const updates = {};
    items.forEach((item) => {
      const parent = item.properties && item.properties._offer_gift_for;
      if (parent && !productIds.has(String(parent))) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return;

    log('kit left the cart, removing its gift');
    postJson('/cart/update.js', { updates: updates })
      .then(() => {
        if (window.fetchCart) window.fetchCart();
      })
      .catch((err) => console.error('[gift-offer] could not remove the offer gift:', err));
  });
})();
